import { render } from "./ReportCreateGroupElement.vue?vue&type=template&id=8e5a52ea&scoped=true"
import script from "./ReportCreateGroupElement.vue?vue&type=script&lang=js"
export * from "./ReportCreateGroupElement.vue?vue&type=script&lang=js"

import "./ReportCreateGroupElement.vue?vue&type=style&index=0&id=8e5a52ea&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e5a52ea"]])

export default __exports__